import React, { useState } from "react";

const CheckoutDL = ({ locations, onSelect, selectedLocation }) => {
  //const [selectedId, setSelectedId] = useState(null);

  const handleSelect = (location) => {
    //setSelectedId(location.locationId);
    onSelect(location);
  };

  return (
    <div className="space-y-4">
      {(Array.isArray(locations) ? locations : []).map((loc) => (
        <label
          key={loc.locationId}
          className={`block border p-4 rounded-lg cursor-pointer ${
            selectedLocation?.locationId === loc.locationId
              ? "border-blue-500 bg-blue-50"
              : "border-gray-300"
          }`}
        >
          <input
            type="radio"
            name="deliveryLocation"
            checked={selectedLocation?.locationId === loc.locationId}
            onChange={() => handleSelect(loc)}
            className="mr-2"
          />
          <div>
            <div className="font-bold">{loc.locationLabel}</div>
            <div>
              {loc.recipientName} ({loc.phoneNumber})
            </div>
            <div>
              {loc.areaName}, {loc.cityName}
            </div>
            {loc.isDefault && (
              <span className="text-sm text-green-600">Default</span>
            )}
          </div>
        </label>
      ))}
    </div>
  );
};

export default CheckoutDL;
